import React, { useState, useEffect ,useRef} from 'react';
import {RenewalsModel} from '../models/RenewalsModel'
import {GeneralDataModel} from '../models/GeneralDataModel'
import { LeadsPageModel, SPLeadModel, LeadModel, LeadFilterModel, SelectListItem } from '../models/superbit-api-models'


type Props = {
    
};





const SalespersonAssignment = (props: Props) => {

    const [vehicleId, setVehicleId] = useState<string | undefined>("");
    
 
    
    useEffect(() => {
       

    }, [props])

useEffect(() => {
        init();
        
    }, [])
    
    

    const init = async () => {
        var model = new GeneralDataModel();
        const handlersData = await model.getClaimHandlers();
        
const salesHandlers = await model.getSalesHandlers();

    };

    function validateGUID(guid: string) {
        const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        return guidPattern.test(guid);
    }

    


    return (
        <div>
            
        </div>



    );
};

//export default forwardRef<ChildRef, Props>(VehicleData);
export default SalespersonAssignment;

